import { Badge } from '@mantine/core';

interface ExpertiseBadgeProps {
  name: string;
}

export function ExpertiseBadge({ name }: ExpertiseBadgeProps) {
  return (
    <Badge
      variant="light"
      size="xs"
      styles={{
        root: { paddingLeft: 6, paddingRight: 6 },
        label: { fontWeight: 600, letterSpacing: 0.2 },
      }}
      color="blue"
    >
      {name}
    </Badge>
  );
}
